<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">UMoney карт үүсгэх</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-header">
          <div class="row form-group">
            <div class="col col-3">
              <label for="text-input" class="form-control-label">Нэр*</label>
            </div>
            <div class="col-9">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
                v-model="name"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="default-tab">
            <div class="d-flex">
              <div
                :class="[{ 'tab--selected' : languageTab === 'MN', 'tab--invalid': mnTabError && languageTab !== 'MN' }, 'nav-link tab']"
                @click="languageTab = 'MN'"
              >MON</div>
              <div
                :class="[{ 'tab--selected' : languageTab === 'EN', 'tab--invalid': enTabError && languageTab !== 'EN' }, 'nav-link tab']"
                @click="languageTab = 'EN'"
              >ENG</div>
            </div>

            <br>
            <!-- MN tab -->
            <div v-if="languageTab === 'MN'">
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Гарчиг*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.0', $v.mntitle)"
                    :class="{ 'is-invalid': $v.mntitle.$error }"
                    v-model="mntitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb)*</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, true)"
                      :class="{ 'is-invalid': $v.mnthumb.$error }"
                    >
                    <div class="invalid-feedback">{{ this.getErrorMsg('thumb.0')[0] }}</div>
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="mnthumb !== ''" v-bind:src="mnthumb" alt>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="select" class="form-control-label">Төрөл*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('type.0', $v.mntype)"
                    :class="{ 'is-invalid': $v.mntype.$error }"
                    v-model="mntype"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('type.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Үнэ*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('price.0', $v.mnprice)"
                    :class="{ 'is-invalid': $v.mnprice.$error }"
                    v-model="mnprice"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('price.0')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Борлуулах салбар*</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('branch.0', $v.mnbranch)"
                    :class="{ 'is-invalid': $v.mnbranch.$error }"
                    v-model="mnbranch"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('branch.0')[0] }}</div>
                </div>
              </div>
            </div>

            <!-- EN tab -->
            <div v-else-if="languageTab === 'EN'">
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Гарчиг{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('title.1', $v.entitle)"
                    :class="{ 'is-invalid': $v.entitle.$error }"
                    v-model="entitle"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('title.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Зураг (thumb){{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <div class="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      class="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      @change="onThumbInput($event, false)"
                      :class="{ 'is-invalid': $v.enthumb.$error }"
                    >
                    <div class="invalid-feedback">{{ this.getErrorMsg('thumb.1')[0] }}</div>
                    <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                  </div>
                  <img class="thumb-image mt-4" v-if="enthumb !== ''" v-bind:src="enthumb" alt>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="select" class="form-control-label">Төрөл{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('type.1', $v.entype)"
                    :class="{ 'is-invalid': $v.entype.$error }"
                    v-model="entype"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('type.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label for="text-input" class="form-control-label">Үнэ{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('price.1', $v.enprice)"
                    :class="{ 'is-invalid': $v.enprice.$error }"
                    v-model="enprice"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('price.1')[0] }}</div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-3">
                  <label
                    for="text-input"
                    class="form-control-label"
                  >Борлуулах салбар{{ notOptional }}</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    id="text-input"
                    name="text-input"
                    class="form-control"
                    v-on:input="onChangeHandler('branch.1', $v.enbranch)"
                    :class="{ 'is-invalid': $v.enbranch.$error }"
                    v-model="enbranch"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('branch.1')[0] }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <button @click="$parent.goBack()" type="submit" class="btn btn-primary mx-2">Буцах</button>
          <button @click="onSubmit" type="submit" class="btn btn-success mx-2">
            <i class="fa fa-dot-circle"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.tab {
  border-bottom: 1px solid lightgray;
  color: blue;
  cursor: pointer;
  flex: 1;
}

.tab--selected {
  border: 1px solid lightgray;
  border-bottom: none;
  color: #555;
}

.tab--invalid {
  border-bottom: 1px solid crimson;
  color: #555;
}
</style>

<script>
import MenuService from "@/services/MenuService";
import Form from "@/mixins/Form.js";
import ImageUploadService from "@/services/ImageUploadService";

export default {
  name: "CardInfoCreate",

  mixins: [Form],

  props: ["parentId"],

  computed: {
    mnTabError() {
      return (
        this.$v.mntitle.$error ||
        this.$v.mnthumb.$error ||
        this.$v.mntype.$error ||
        this.$v.mnprice.$error ||
        this.$v.mnbranch.$error
      );
    },

    enTabError() {
      return (
        this.$v.entitle.$error ||
        this.$v.enthumb.$error ||
        this.$v.entype.$error ||
        this.$v.enprice.$error ||
        this.$v.enbranch.$error
      );
    },

    notOptional() {
      return this.hasEngdata() ? "*" : "";
    }
  },

  data() {
    return {
      name: "",
      mntitle: "",
      entitle: "",
      mnthumb: "",
      enthumb: "",
      mntype: "",
      entype: "",
      mnprice: "",
      enprice: "",
      mnbranch: "",
      enbranch: ""
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    mntitle: {
      serverFailed: function() {
        return !this.hasServerError("title.0");
      }
    },
    entitle: {
      serverFailed: function() {
        return !this.hasServerError("title.1");
      }
    },
    mnthumb: {
      serverFailed: function() {
        return !this.hasServerError("thumb.0");
      }
    },
    enthumb: {
      serverFailed: function() {
        return !this.hasServerError("thumb.1");
      }
    },
    mntype: {
      serverFailed: function() {
        return !this.hasServerError("type.0");
      }
    },
    entype: {
      serverFailed: function() {
        return !this.hasServerError("type.1");
      }
    },
    mnprice: {
      serverFailed: function() {
        return !this.hasServerError("price.0");
      }
    },
    enprice: {
      serverFailed: function() {
        return !this.hasServerError("price.1");
      }
    },
    mnbranch: {
      serverFailed: function() {
        return !this.hasServerError("branch.0");
      }
    },
    enbranch: {
      serverFailed: function() {
        return !this.hasServerError("branch.1");
      }
    }
  },

  methods: {
    serverRequest: MenuService.createCard,

    successHandler(response) {
      if (response.data.payload.toast != null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/submenu/" + this.parentId);
    },

    createJsonData() {
      let data = JSON.parse("{}");
      data.parentId = this.$route.params.parentId;
      data.name = this.name;
      data.contents = [];

      let mncontent = JSON.parse("{}");
      mncontent.language = 1;
      mncontent.title = this.mntitle;
      mncontent.thumb = this.mnthumb;
      mncontent.type = this.mntype;
      mncontent.price = this.mnprice;
      mncontent.branch = this.mnbranch;
      data.contents.push(mncontent);

      if (this.hasEngdata()) {
        let encontent = JSON.parse("{}");
        encontent.language = 2;
        encontent.title = this.entitle;
        encontent.thumb = this.enthumb;
        encontent.type = this.entype;
        encontent.price = this.enprice;
        encontent.branch = this.enbranch;
        data.contents.push(encontent);
      }
      return data;
    },

    hasEngdata() {
      return (
        this.entitle != "" ||
        this.entype != "" ||
        this.enthumb != "" ||
        this.enprice != "" ||
        this.enbranch != ""
      );
    },

    onThumbInput(event, isMon) {
      if (event.target.files[0] != null) {
        const data = new FormData();
        data.append("image", event.target.files[0]);
        ImageUploadService.uploadImage(data).then(response => {
          if (isMon) {
            this.mnthumb = response.data;
            this.onChangeHandler("thumb.0", this.$v.mnthumb);
          } else {
            this.enthumb = response.data;
            this.onChangeHandler("thumb.1", this.$v.enthumb);
          }
        });
      }
    }
  }
};
</script>